import { Stack } from '@mui/material';
import {
  DurationField,
  MeasuredAsField,
  QuantifyFeedbackFieldGroup,
  WhereClauseField,
} from './Fields';

export function QuantifyQueryComposer() {
  return (
    <Stack width={425}>
      <QuantifyFeedbackFieldGroup />
      <WhereClauseField />
      <DurationField />
      <MeasuredAsField />
    </Stack>
  );
}
